<template>
    <div class="category-preview relative">
        <img
            :src="category.thumbnail + '?w=500&h=500&fit=crop'"
            :alt="category.title"
            v-if="category.thumbnail"
        >
        <img src="../assets/img/placeholder.svg" :alt="category.title" v-else>
        <div class="category-preview__description text-center">
            <h4>{{ category.title }}</h4>
        </div>
        <router-link :to="{ name: 'shop', params: { category: category.slug } }" class="full-link"></router-link>
    </div>
</template>

<script>
export default {
    props: ["category"]
};
</script>

<style lang="scss" scoped>
.category-preview {
    background-color: $white;

    img {
        width: 100%;
        height: auto;
    }

    .category-preview__description {
        padding: 15px 25px;
    }
}
</style>

